// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.link[data-v-74753ccb]\n{\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
